// extracted by mini-css-extract-plugin
module.exports = {"left":"Notify_left__qc6tD","right":"Notify_right__2m-l_"};